// extracted by mini-css-extract-plugin
export default {"app":"W+KEp","scrollable":"Dl+hJ"};